import "./App.css";
//import Navbar from "./component/navbar";
import Login from "./component/login";
import Navbar from "./component/navbar";
import {  Route, Routes } from "react-router-dom";
function App() {
  return (
    <div className="App">
         <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/navbar/*" element={<Navbar />} /> 
        </Routes>
      
    </div>
  );
}

export default App;